import React from 'react'

import { userTypes } from 'constants/user'
import avatarStore from 'utils/avatarStore'
import { getTeacherGender } from 'utils/gender'

import { defaultHead } from './defaults/head'
import { Wrapper, DefaultAvatar } from './styles'

/**
 * this is a resuable avatar component
 * to apply styles, add a wrapper div around this, whereever this component is reused
 * eg. usage can be found in Tiles/Student/index.js
 * */

const AVATAR_BASE = `/img/tiles/avatars`

const getDefaultAvatar = isTeacher => {
    if (!isTeacher) return `${AVATAR_BASE}/student.default.svg`

    const teacherGender = getTeacherGender()
    const src = teacherGender.isMale
        ? `${AVATAR_BASE}/defaultMaleTeacherWOBg.svg`
        : `${AVATAR_BASE}/defaultFemaleTeacherWOBg.svg`
    return src
}

const Avatar = ({
    uuid = '',
    userType = userTypes.STUDENT,
    headOnly = false,
    withBackground = true,
}) => {
    const isTeacher = userType === userTypes.TEACHER
    const defaultAvatar = (
        <DefaultAvatar
            isTeacher={isTeacher}
            alt={`avatar-${uuid}`}
            src={getDefaultAvatar(isTeacher)}
            withBackground={withBackground}
        />
    )
    const avatar = avatarStore.get(uuid)

    if (headOnly) {
        const head = avatar?.head
        const svgHeadHtml = `<svg viewBox="90 0 320 410" fill="none" xmlns="http://www.w3.org/2000/svg" >${head}</svg>`
        return head ? (
            <Wrapper dangerouslySetInnerHTML={{ __html: svgHeadHtml }} />
        ) : (
            defaultHead
        )
    }

    const fullSvgPath = avatar?.svg

    if (!fullSvgPath || isTeacher) return defaultAvatar

    const background = withBackground ? avatar?.background || '' : '' // fallback if background is null
    const path = background + fullSvgPath
    const viewBox = '0 0 503 511'

    const svgHtml = `<svg viewBox="${viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg" >${path}</svg>`

    return <Wrapper dangerouslySetInnerHTML={{ __html: svgHtml }} />
}

export default Avatar
